<template>
  <div id="comingSoon" class="flex justify-center items-center min-h-[calc(100vh-18vh)] h-[calc(100%-18vh)]">
    <div class="text-4xl font-bold text-button-brown">{{ t("home.pathNotFound") }}</div>
    <img src="@/assets/images/shared/starGroupIconBrown.svg" class="absolute right-0 bottom-0 pb-20" style="width: 9.6vw" />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, toRefs } from "vue";
import { useHeaderStore } from "@/stores/header";
import { useCommonStore } from "@/stores/common";

import { useI18n } from "vue-i18n";

const commonStore = useCommonStore();
const headerStore = useHeaderStore();
//debugger;
const { t, locale } = useI18n();

onMounted(async () => {
  //set max height
  /*
  var headerHeight = document.getElementById("header").offsetHeight;
  console.log("header height: " + headerHeight);
  document.getElementById("comingSoon").style.minHeight = "calc( 100vh - " + (headerHeight + 5) + "px )";
  document.getElementById("comingSoon").style.height = "calc( 100% - " + (headerHeight + 5) + "px )";
*/
});
</script>

<style>
</style>